/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Desk_Illustration_AltInputs */

const en_landing_capability_desk_illustration_alt = /** @type {(inputs: Landing_Capability_Desk_Illustration_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market signals matched to the clients who should hear them first`)
};

/**
* | output |
* | --- |
* | "Market signals matched to the clients who should hear them first" |
*
* @param {Landing_Capability_Desk_Illustration_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_desk_illustration_alt = /** @type {((inputs?: Landing_Capability_Desk_Illustration_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Desk_Illustration_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_desk_illustration_alt(inputs)
});